// @ts-check
import React from 'react';
import { AuthProvider } from 'react-oidc-context';
import getAppConfigs from 'modules/appConfig/reducer';
import OidcSilentProvider from './silentProvider';
import ApiConnector from './ApiConnector';
import ApiUnauthorizedConnector from './ApiUnauthorizedConnector';
import ReduxConnector from './ReduxConnector';
import GtmConnector from './GtmConnector';

const appConfigs = getAppConfigs();

// storybook public url is '.'
const publicURL = process.env.PUBLIC_URL === '.' ? '/' : process.env.PUBLIC_URL;

const redirectUrl = new URL(
	'oidc/callback',
	`${globalThis.location?.origin}${publicURL}`,
);

/** @type {import('react-oidc-context').AuthProviderProps} */
const oidcSettings = {
	authority: appConfigs?.openId.authority,
	client_id: appConfigs?.openId.client_id,
	accessTokenExpiringNotificationTimeInSeconds:
		appConfigs?.openId.accessTokenExpiringNotificationTimeInSeconds,
	redirect_uri: redirectUrl.href,
	response_type: 'code',
	scope: 'openid profile grants',
	client_secret: '',
	popupWindowFeatures: {
		width: 520,
		height: 800,
	},
	// TODO DEV-5172 remove this
	metadata: {
		issuer: appConfigs?.openId?.authority,
		authorization_endpoint: `${appConfigs?.openId?.authority}/authorize`,
		token_endpoint: `${appConfigs?.openId?.authority}/token`,
		jwks_uri: `${appConfigs?.openId?.authority}/publickeys`,
		end_session_endpoint: `${appConfigs?.openId?.authority}/logout`,
		userinfo_endpoint: `${appConfigs?.openId?.authority}/userinfo`,
	},
};

/**
 * @param {Object} props
 * @param {*} props.children
 */
export function OidcProvider({ children }) {
	return (
		<AuthProvider {...oidcSettings}>
			<OidcSilentProvider>
				<ApiConnector />
				<ApiUnauthorizedConnector />
				<ReduxConnector />
				<GtmConnector />
				{children}
			</OidcSilentProvider>
		</AuthProvider>
	);
}

export default OidcProvider;
